/*
  Upsell (compact) — toggle del micro-upsell nel cart drawer.

  Non contiene logica di carrello propria: riusa quella del tema.
    ON  -> click sul submit del <product-form> nascosto  (product-form.js -> /cart/add.js -> cart.renderContents)
    OFF -> <cart-drawer-items>.updateQuantity(line, 0)   (cart.js -> /cart/change.js -> re-render sezioni)
  Entrambe ri-renderizzano il drawer in place: nessun reload, drawer aperto.

  Il listener e' delegato su `document` e registrato una sola volta: sopravvive
  ai re-render del drawer (che sostituiscono l'innerHTML di #CartDrawer, dove
  i <script> non vengono rieseguiti).
*/
(function () {
  if (window.__cartCompactUpsellReady) return;
  window.__cartCompactUpsellReady = true;

  var busy = false;
  var releaseTimer = null;

  /*
    "Selected by default" (impostazione del blocco): la riga parte gia' accesa.
    Non esiste uno stato lato tema — lo stato E' il carrello — quindi "acceso di
    default" significa aggiungere il prodotto UNA volta, appena il carrello ha
    qualcosa dentro. Se il cliente lo spegne resta spento FINCHE' non lo riaccende
    lui: il "no" e' ricordato in localStorage e si cancella solo quando riaccende
    l'interruttore a mano. `autoTried` evita di riprovare in ciclo su ogni
    re-render quando l'aggiunta fallisce.
  */
  var OPT_OUT_KEY = 'cartMicroUpsellOptOut';
  var checking = false;
  var failCount = 0;    // solo anti-loop: 2 richieste andate male e si smette
  var hadIt = false;    // la protezione c'era all'ultimo controllo?
  var pendingAdd = false;
  var syncQueued = false;   // un controllo arrivato mentre eravamo occupati
  var lastOthers = '';  // firma del RESTO del carrello all'ultimo controllo

  function optedOut() {
    try {
      return window.localStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markOptOut() {
    try {
      window.localStorage.setItem(OPT_OUT_KEY, '1');
    } catch (e) {
      /* storage negato (private mode): resta valido per il solo render corrente */
    }
  }

  // l'ha riacceso a mano: il rifiuto di prima non vale piu'
  function clearOptOut() {
    try {
      window.localStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}
  }

  /*
    Aggiorna a mano le sezioni che il carrello ri-renderizza. Non si usa
    cart-drawer.renderContents(): quello APRE il drawer, e qui il cliente non ha
    chiesto niente — la riga deve solo risultare gia' accesa quando lo aprira'.
  */
  /*
    Sezioni da far ri-renderizzare al server. Nel drawer bastano le due fisse;
    nella pagina /cart i nomi dipendono dal template, e solo il tema li sa:
    glieli si chiede invece di indovinarli.
  */
  function sectionsWanted() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var page = pageSections();
    for (var i = 0; i < page.length; i++) {
      if (list.indexOf(page[i].section) < 0) list.push(page[i].section);
    }
    return list.join(',');
  }

  function pageSections() {
    var ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function') return [];
    try {
      return ci.getSectionsToRender() || [];
    } catch (e) {
      return [];
    }
  }

  function applySections(sections) {
    if (!sections) return;

    // sezioni della pagina carrello, con la stessa mappa che usa il tema
    var page = pageSections();
    for (var i = 0; i < page.length; i++) {
      var s = page[i];
      var html = sections[s.section];
      if (!html) continue;
      var host = document.getElementById(s.id);
      if (!host) continue;
      var target = (s.selector && host.querySelector(s.selector)) || host;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (fresh) target.innerHTML = fresh.innerHTML;
    }
    /*
      Stessa mappa che usa il tema in cart-drawer.getSectionsToRender():
      il drawer si rimpiazza dentro #CartDrawer, l'icona del carrello prende il
      contenuto di .shopify-section. Presa dal tema e non inventata, altrimenti
      un selettore che non combacia lascia il CONTEGGIO dell'icona indietro di
      un articolo (visto il 2026-08-14: carrello 2, icona ferma a 1).
    */
    function innerOf(html, selector) {
      if (!html) return null;
      var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : null;
    }
    var drawer = document.querySelector('#CartDrawer');
    var drawerHtml = innerOf(sections['cart-drawer'], '#CartDrawer');
    if (drawer && drawerHtml !== null) drawer.innerHTML = drawerHtml;

    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleHtml = innerOf(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;

    /*
      L'aspetto "carrello vuoto" dipende dalla classe is-empty sull'elemento
      <cart-drawer>, che sta FUORI dal pezzo che abbiamo appena riscritto:
      senza questa riga il drawer resta vestito da carrello pieno con dentro il
      nulla (segnalato: "non ha il design di quando e' vuoto").
    */
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.toggle('is-empty', drawerEl.querySelector('.cart-item') === null);

    mirrorOnCartPage();
  }

  /*
    Pagina /cart: la riga della protezione e' nascosta dall'elenco (sembrava un
    prodotto, con quantita' e cestino) e ricompare qui sotto il subtotale, uguale
    a quella del drawer. Si ricopia il nodo invece di ri-renderizzarlo: le
    impostazioni vivono nel blocco del cart-drawer e da questa sezione Liquid non
    si leggono.
  */
  function mirrorOnCartPage() {
    var totals = document.querySelector('#main-cart-footer .totals');
    if (!totals) return;                 // non siamo nella pagina carrello

    var old = document.querySelector('.cart-page-upsell');
    if (old) old.parentNode.removeChild(old);

    var source = document.querySelector('#CartDrawer [data-cart-micro-upsell]');
    if (!source) return;

    var wrap = document.createElement('div');
    wrap.className = 'cart-page-upsell';
    var copy = source.cloneNode(true);
    copy.removeAttribute('id');
    var withId = copy.querySelectorAll('[id]');
    for (var i = 0; i < withId.length; i++) withId[i].removeAttribute('id');
    wrap.appendChild(copy);
    totals.parentNode.insertBefore(wrap, totals.nextSibling);
  }

  function drainQueue() {
    if (!syncQueued) return;
    syncQueued = false;
    syncCart();
  }

  function syncCart() {
    /*
      Occupati: si RICORDA il giro invece di buttarlo via. Senza la coda, un
      cliente che riaccendeva la protezione e subito dopo toglieva il prodotto
      restava con la sola protezione da 0,99 nel carrello: il controllo di
      pulizia cadeva proprio nella finestra dell'operazione precedente.
    */
    if (checking || pendingAdd) { syncQueued = true; return; }
    var root = document.querySelector('[data-cart-micro-upsell]');
    if (!root) return;
    var idInput = root.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var isOn = root.classList.contains('is-on');
    var wantsDefault = root.hasAttribute('data-default-on') && !optedOut();
    // niente da accendere, niente da ripulire, nessun rifiuto da registrare
    if (!isOn && !wantsDefault && !hadIt) return;
    if (failCount >= 2) return;

    var submit = root.querySelector('[data-cart-micro-upsell-submit]');
    var id = Number(idInput.value);
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var payload = { sections: sectionsWanted(), sections_url: window.location.pathname };

    /*
      Si chiede sempre al carrello com'e' fatto ADESSO: il markup e' una foto del
      momento del render e puo' mentire (carrello svuotato in un'altra scheda).
      E non si passa mai dal <product-form> del tema: al primo giro <cart-drawer>
      puo' non essere ancora "acceso", product-form muore prima della richiesta e
      lascia il bottone bloccato (aria-disabled), ignorando anche i click veri.
    */
    checking = true;
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var line = null;
        var others = 0;
        var signature = [];
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.variant_id === id || it.id === id) {
            line = it;
          } else {
            others += it.quantity;
            signature.push(it.key + ':' + it.quantity);
          }
        }
        signature = signature.sort().join('|');
        var othersUnchanged = signature === lastOthers;
        lastOthers = signature;

        // rimasta da sola: si toglie, altrimenti il carrello sembra vuoto e costa 0,99
        if (line && others === 0) {
          hadIt = false;
          return post(base + 'cart/change.js', Object.assign({ id: line.key, quantity: 0 }, payload));
        }
        if (line) {
          hadIt = true;
          /*
            Rete di sicurezza: due schede aperte insieme possono aggiungerla
            entrambe e il carrello somma le quantita'. Di protezioni se ne paga
            UNA sola, quindi si riporta a 1.
          */
          if (line.quantity > 1) {
            return post(base + 'cart/change.js', Object.assign({ id: line.key, quantity: 1 }, payload));
          }
          return null;
        }

        /*
          C'era e ora non c'e' piu', ma il carrello e' ancora pieno: l'ha tolta il
          cliente dalla riga del carrello invece che dall'interruttore. Vale come
          un no, altrimenti il default gliela rimette addosso ogni volta.
        */
        /*
          Solo se il RESTO del carrello e' rimasto identico: se sono cambiati
          anche gli altri articoli e' successo altro (svuotato e ricominciato,
          un altro prodotto aggiunto) e scambiarlo per un rifiuto spegnerebbe
          il default per sempre. Misurato: senza questo controllo, un
          "svuota e riparti" veniva segnato come no.
        */
        if (hadIt && others > 0 && othersUnchanged) {
          hadIt = false;
          markOptOut();
          return null;
        }
        if (hadIt && others > 0) hadIt = false;
        // carrello svuotato del tutto: si riparte da zero, non e' un rifiuto
        if (others === 0) { hadIt = false; return null; }
        /*
          Si ricontrolla ADESSO, non con il valore calcolato prima della
          richiesta: il cliente puo' aver spento l'interruttore mentre /cart.js
          era in volo, e con la vecchia lettura la protezione gli tornava.
        */
        if (!root.hasAttribute('data-default-on') || optedOut()) return null;
        if (submit && submit.hasAttribute('disabled')) return null;

        return post(base + 'cart/add.js', Object.assign({ items: [{ id: id, quantity: 1 }] }, payload))
          .then(function (ok) {
            if (ok === false) failCount += 1;
            else hadIt = true;
          });
      })
      .catch(function () {
        /* rete giu': il carrello resta com'e', nessuno stato bloccato */
      })
      .then(function () { checking = false; drainQueue(); });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return false;
        applySections(data.sections);
        return true;
      });
  }

  function release() {
    busy = false;
    if (releaseTimer) {
      clearTimeout(releaseTimer);
      releaseTimer = null;
    }
  }

  /*
    Il toggle si muove SUBITO, prima che il server risponda: sulla rete di un
    telefono il giro completo (add/change + re-render della sezione) e' di
    qualche centinaio di ms, e un interruttore che non reagisce al tocco viene
    letto come "non ha funzionato" (e ricliccato). Lo stato vero arriva comunque
    con il re-render, che riscrive questo HTML; se la richiesta fallisce, il
    timer di sicurezza rimette il toggle com'era.
  */
  function lock(root, wantOn) {
    busy = true;
    var was = root.classList.contains('is-on');
    root.classList.add('is-busy');
    root.classList.toggle('is-on', wantOn);
    releaseTimer = setTimeout(function () {
      busy = false;
      releaseTimer = null;
      var live = document.querySelector('[data-cart-micro-upsell]');
      if (live) {
        live.classList.remove('is-busy');
        live.classList.toggle('is-on', was);
      }
    }, 6000);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest ? event.target.closest('[data-cart-micro-upsell-toggle]') : null;
    if (!toggle) return;

    event.preventDefault();
    if (busy || toggle.hasAttribute('disabled')) return;

    var root = toggle.closest('[data-cart-micro-upsell]');
    if (!root) return;

    if (root.classList.contains('is-on')) {
      var line = parseInt(root.getAttribute('data-line'), 10);
      var drawerItems = document.querySelector('cart-drawer-items');
      var items = drawerItems || document.querySelector('cart-items');
      if (!line || !items || typeof items.updateQuantity !== 'function') return;
      /*
        Nella pagina /cart esistono ENTRAMBI (il drawer sta nel layout di ogni
        pagina): decide la PAGINA, non quale elemento si trova per primo.
        Sbagliando qui, il tema aggiornava solo il drawer e il subtotale della
        pagina restava indietro.
      */
      var onCartPage = !!document.getElementById('main-cart-footer');
      markOptOut();
      lock(root, false);
      if (drawerItems && !onCartPage) {
        items.updateQuantity(line, 0);   // strada del tema, collaudata nel drawer
      } else {
        /*
          Pagina /cart: la riga della protezione e' nascosta e il tema non
          ridisegna il subtotale quando l'azione parte dalla copia sotto i
          totali (misurato: restava 26,94 con carrello a 25,95).
        */
        var key = root.getAttribute('data-key');
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        post(base + 'cart/change.js', {
          line: line,
          quantity: 0,
          sections: sectionsWanted(),
          sections_url: window.location.pathname
        });
      }
    } else {
      var submit = root.querySelector('[data-cart-micro-upsell-submit]');
      if (!submit || submit.hasAttribute('disabled')) return;
      clearOptOut();
      lock(root, true);
      /*
        pendingAdd anche qui: senza, l'aggancio "aggiungi insieme al prodotto"
        vedeva passare la richiesta del toggle e ne aggiungeva una SECONDA
        (misurato: 27,93 invece di 26,94).
      */
      pendingAdd = true;
      var onCartPage2 = !!document.getElementById('main-cart-footer');
      var idInput2 = root.querySelector('input[name="id"]');
      if (onCartPage2 && idInput2 && idInput2.value) {
        // nella pagina /cart la richiesta la facciamo noi, cosi' si aggiornano
        // anche subtotale ed elenco della pagina e non solo il drawer
        var base2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        post(base2 + 'cart/add.js', {
          items: [{ id: Number(idInput2.value), quantity: 1 }],
          sections: sectionsWanted(),
          sections_url: window.location.pathname
        })
          .then(function (ok) { if (ok !== false) hadIt = true; })
          .catch(function () {})
          .then(function () { pendingAdd = false; drainQueue(); });
      } else {
        submit.click();
        setTimeout(function () { pendingAdd = false; drainQueue(); }, 2000);
      }
    }
  });

  /*
    Rientro dopo ogni re-render del carrello. NON si usa il pubsub del tema:
    qui `PUB_SUB_EVENTS` e' undefined (misurato 2026-08-14), quindi
    subscribe(PUB_SUB_EVENTS.cartUpdate, ...) lanciava e il gancio non c'era.
    L'osservatore e' filtrato sul rientro della riga upsell, cosi' il countdown
    che riscrive un testo ogni secondo non lo sveglia.
  */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        release();
        syncCart();
      });
    }
  } catch (e) {
    /* pubsub non disponibile: ci pensa l'osservatore qui sotto */
  }

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1 || typeof node.querySelector !== 'function') continue;
          if (node.matches('[data-cart-micro-upsell]') || node.querySelector('[data-cart-micro-upsell]')) {
            release();
            syncCart();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /*
    Aggiunta contestuale: quando parte una richiesta di aggiunta al carrello del
    tema, la protezione parte NELLA STESSA finestra invece che dopo il giro di
    verifica. Si osserva soltanto la richiesta, non la si tocca: rompere
    l'aggiunta al carrello del tema sarebbe molto peggio di un ritardo.
  */
  if (typeof window.fetch === 'function') {
    var themeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && String(method).toUpperCase() === 'POST';
      if (!isAdd) return themeFetch.apply(this, arguments);

      if (!mergeIntoRequest(init)) {
        // richiesta lasciata intatta: la protezione, se serve, si aggiunge a parte
        var plain = themeFetch.apply(this, arguments);
        addAlongside();
        return plain;
      }

      // un'unica scrittura sul carrello: prodotto e protezione insieme
      pendingAdd = true;
      hadIt = true;
      return themeFetch.apply(this, arguments)
        .then(function (r) { pendingAdd = false; drainQueue(); return r; })
        .catch(function (err) { pendingAdd = false; hadIt = false; drainQueue(); throw err; });
    };
  }

  /*
    Prova a costruire il corpo di una richiesta unica (prodotto + protezione).
    Torna null quando non e' il caso di toccare niente: allora la richiesta del
    tema passa intatta e la protezione viene aggiunta a parte.
  */
  /*
    Aggiunge la protezione DENTRO la richiesta del tema, cosi' il carrello viene
    scritto una volta sola e la riga compare insieme al prodotto (Shopify
    serializza le scritture: due richieste separate = ~300-500 ms di scarto).
    Si lavora sul FormData che il tema ha gia' costruito — non lo si converte —
    e si torna false appena qualcosa non torna: in quel caso la richiesta parte
    intatta e la protezione viene aggiunta a parte.
  */
  function mergeIntoRequest(init) {
    try {
      if (!init || !init.body) return false;
      if (typeof FormData === 'undefined' || !(init.body instanceof FormData)) return false;
      if (checking || pendingAdd || optedOut() || failCount >= 2) return false;

      var variantId = defaultVariantId();
      if (!variantId) return false;

      var fd = init.body;
      var keys = [];
      var it = fd.entries();
      var e = it.next();
      while (!e.done) { keys.push(e.value[0]); e = it.next(); }

      // la richiesta porta gia' piu' articoli (offerte a quantita'): si accoda
      var maxIndex = -1;
      for (var i = 0; i < keys.length; i++) {
        var mm = keys[i].match(/^items\[(\d+)\]/);
        if (mm) maxIndex = Math.max(maxIndex, Number(mm[1]));
      }
      if (maxIndex >= 0) {
        fd.append('items[' + (maxIndex + 1) + '][id]', variantId);
        fd.append('items[' + (maxIndex + 1) + '][quantity]', 1);
        return true;
      }

      // articolo singolo: diventa items[0], la protezione items[1]
      var id = fd.get('id');
      if (!id || Number(id) === variantId || String(id).indexOf(',') >= 0) return false;
      var qty = fd.get('quantity') || 1;

      var props = [];
      for (var j = 0; j < keys.length; j++) {
        var pm = keys[j].match(/^properties\[(.+)\]$/);
        if (pm) props.push([pm[1], fd.get(keys[j])]);
      }
      var sellingPlan = fd.get('selling_plan');

      fd.delete('id');
      fd.delete('quantity');
      fd.delete('selling_plan');
      for (var k = 0; k < props.length; k++) fd.delete('properties[' + props[k][0] + ']');

      fd.append('items[0][id]', id);
      fd.append('items[0][quantity]', qty);
      if (sellingPlan) fd.append('items[0][selling_plan]', sellingPlan);
      for (var q = 0; q < props.length; q++) {
        fd.append('items[0][properties][' + props[q][0] + ']', props[q][1]);
      }
      fd.append('items[1][id]', variantId);
      fd.append('items[1][quantity]', 1);
      return true;
    } catch (err) {
      return false;   // nel dubbio non si tocca l'aggiunta al carrello
    }
  }

  function defaultVariantId() {
    var root = document.querySelector('[data-cart-micro-upsell]');
    if (root) {
      if (root.classList.contains('is-on') || !root.hasAttribute('data-default-on')) return 0;
      var input = root.querySelector('input[name="id"]');
      var submit = root.querySelector('[data-cart-micro-upsell-submit]');
      if (submit && submit.hasAttribute('disabled')) return 0;
      return input && input.value ? Number(input.value) : 0;
    }
    var cfg = document.querySelector('[data-cart-micro-upsell-config]');
    if (!cfg || !cfg.hasAttribute('data-default-on')) return 0;
    if (cfg.getAttribute('data-available') !== '1') return 0;
    return Number(cfg.getAttribute('data-variant')) || 0;
  }

  function addAlongside() {
    if (checking || pendingAdd || optedOut() || failCount >= 2) return;

    var variantId = 0;
    var root = document.querySelector('[data-cart-micro-upsell]');
    if (root) {
      // il corpo dell'upsell c'e': se e' gia' accesa non serve fare nulla
      if (root.classList.contains('is-on') || !root.hasAttribute('data-default-on')) return;
      var idInput = root.querySelector('input[name="id"]');
      var submit = root.querySelector('[data-cart-micro-upsell-submit]');
      if (submit && submit.hasAttribute('disabled')) return;
      if (idInput && idInput.value) variantId = Number(idInput.value);
    } else {
      // carrello vuoto: il corpo non esiste, i dati stanno nel segnaposto
      var cfg = document.querySelector('[data-cart-micro-upsell-config]');
      if (!cfg || !cfg.hasAttribute('data-default-on')) return;
      if (cfg.getAttribute('data-available') !== '1') return;
      variantId = Number(cfg.getAttribute('data-variant'));
    }
    if (!variantId) return;

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    pendingAdd = true;
    post(base + 'cart/add.js', {
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionsWanted(),
      sections_url: window.location.pathname
    })
      .then(function (ok) {
        if (ok === false) failCount += 1;
        else hadIt = true;
      })
      .catch(function () {})
      .then(function () { pendingAdd = false; drainQueue(); });
  }

  // primo giro: il drawer e' gia' nel DOM a ogni caricamento di pagina
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncCart(); mirrorOnCartPage(); });
  } else {
    syncCart();
    mirrorOnCartPage();
  }

  /*
    Theme Editor: cambiare l'impostazione ri-renderizza SOLO la sezione, senza
    DOMContentLoaded e senza cartUpdate. Senza questo aggancio la casella
    "Selected by default" non fa niente finche' non si ricarica l'anteprima.
  */
  document.addEventListener('shopify:section:load', syncCart);
})();
